<template>
  <a-card :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>
          <a-col :span='6'>
            <a-form-item label='话机用户名'>
              <a-input :placeholder="$t('enter') + ' 话机用户名' "
                       v-model='queryParam.username'></a-input>
            </a-form-item>
          </a-col>
          <a-col :span='6'>
            <a-form-item label='呼叫号码'>
              <a-input :placeholder="$t('enter') + '呼叫号码 '"
                       v-model='queryParam.phone' type='number'></a-input>
            </a-form-item>
          </a-col>
          <a-col :span='6'>
            <a-form-item label='显示号码'>
              <a-input :placeholder="$t('enter') + '显示号码'"
                       v-model='queryParam.showPhone' type='number'></a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter='12'>
          <a-col :span='6'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset')
                }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        bordered>
        <!--        <template slot='direction' slot-scope='text, record'>-->
        <!--          <div v-if='text == 1'>-->
        <!--            呼出-->
        <!--          </div>-->
        <!--          <div v-else>-->
        <!--            呼入-->
        <!--          </div>-->
        <!--        </template>-->
        <template slot='record' slot-scope='text, record'>
          <div v-if='text == 1'>
            录音
          </div>
          <div v-else>
            不录音
          </div>
        </template>
      </a-table>
      <div style='margin-top: 15px; text-align: right;'>
        <v-pagination
          v-if='total'
          :page-num='form.pageNum'
          :page-size='form.pageSize'
          :total='total'
          @change='handleTableChange' />
      </div>
    </div>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getcalllogList } from '@/webpublicapi/collection'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import moment from 'moment'
import OrderDetail from '@/views/webpublic/order/OrderDetail.vue'
import vModal from '@/views/webpublic/modules/Modal.vue'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  APPROVAL: 'approval.'
}

export default {
  name: 'AllApprovalTask',
  components: {
    vModal, OrderDetail,
    Dict,
    DictSelect
  },
  data() {
    return {
      paramsVal: {},
      I18N_KEY,
      visible: false,
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      queryParam: {
        username: '',
        phone: '',
        showPhone: ''
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '话机用户名',
          align: 'left',
          dataIndex: 'username'
        },
        {
          title: '话机id',
          align: 'left',
          dataIndex: 'sipid'
        },
        {
          title: '国家代码',
          align: 'left',
          dataIndex: 'code'
        },
        {
          title: '呼叫号码',
          align: 'left',
          dataIndex: 'phone'

        },
        {
          title: '显示号码',
          align: 'left',
          dataIndex: 'showPhone'
        },
        {
          title: '呼叫时长（秒）',
          align: 'left',
          dataIndex: 'duration'
        },
        // {
        //   title: '呼叫方向',
        //   align: 'left',
        //   dataIndex: 'direction',
        //   scopedSlots: { customRender: 'direction' } //1呼出 0呼入
        // },
        {
          title: '是否录音',
          align: 'left',
          dataIndex: 'record',
          scopedSlots: { customRender: 'record' } //1录音 0不录音
        },
        {
          title: '录音访问地址',
          align: 'left',
          dataIndex: 'recordUrl'
        },
        {
          title: '开始时间',
          align: 'left',
          dataIndex: 'startTime'
        },
        {
          title: '接通时间',
          align: 'left',
          dataIndex: 'answerTime'
        },
        {
          title: '挂机原因',
          align: 'left',
          dataIndex: 'hangupCause'
        },
        {
          title: '渠道',
          align: 'left',
          dataIndex: 'channel'
        }

        // {
        //   title: this.$t('action'),
        //   dataIndex: 'action',
        //   align: 'center',
        //   width: 200,
        //   scopedSlots: { customRender: 'action' }
        // }
      ]
    }
  },
  created() {
    this.loadData(1)
  },
  methods: {

    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      if (arg === 1) {
        this.form.pageNum = 1
      }
      var params = this.getQueryParams()
      console.log('params烦死了！！！！！！！！！！！', params)
      if (params == null) {

      } else {
        this.loading = true
        getcalllogList(Object.assign({}, params)).then((res) => {
          if (res.code === 1000) {
            console.log('res------->', res)
            this.dataSource = res.data.list
            this.total = res.data.total
          } else {
            this.total = 0
            this.dataSource = []
            this.$message.error(res.msg)
          }
          this.loading = false
        }).catch(e => {
          this.loading = false
          this.$message.error(e.message)
        })
      }
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    getQueryParams() {
      this.paramsVal = {
        ...this.queryParam
      }
      //分页参数
      this.paramsVal.pageNum = this.form.pageNum
      this.paramsVal.pageSize = this.form.pageSize
      delete this.paramsVal.orderGenerationDate
      return filterObj(this.paramsVal)
    },

    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.username = ''
      that.queryParam.showPhone = ''
      that.queryParam.orderGenerationDate = []//[moment().add('days'), moment().add('days', 0)]
      that.queryParam.phone = ''
      that.loadData(this.form.pageNum)
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";

/deep/ .ant-modal {
  width: 600px !important;
}
</style>
